import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hb_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const CATEGORIES = [
  { slug: "wigs", label: "Wigs" },
  { slug: "bundles", label: "Hair Bundles" },
  { slug: "frontals", label: "Frontals" },
  { slug: "closures", label: "Closures" },
  { slug: "hair-care", label: "Hair Care" },
  { slug: "accessories", label: "Accessories" },
];

export const formatGBP = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n || 0);
